import React from 'react';
import { Select, MenuItem, styled } from '@nextiva/next-ui-components';
import PropTypes from 'prop-types';

import { actionTypes } from 'containers/TeamPhoneNumber/reducer';

const StyledSelect = styled(Select)`
  & .MuiSelect-select {
    padding: 10px 24px 10px 12px;
    cursor: pointer;
    width: 100%;
  }
`;

// Yes, this component is poorly composed and highly inflexible.
// Don't ever reuse this anywhere outside of TeamPhoneNumberContainer.jsx it is that bad. #deadlinesLOL
export const RhfSelect = ({ dispatch, field, determineCanSave, options }) => {
  return (
    <StyledSelect
      disableUnderline
      fullWidth
      MenuProps={{
        getContentAnchorEl: null,
        PaperProps: {
          style: {
            marginTop: 5,
            maxHeight: 250,
          },
        },
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'left',
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'left',
        },
      }}
      {...field}
      onChange={(event) => {
        if (dispatch) {
          dispatch({
            type: actionTypes.UPDATE_AVAILABLE_NUMBERS,
            payload: { newVal: event.target.value, prevVal: field.value },
          });
        }
        field.onChange(event);
        determineCanSave();
      }}
      data-testid="PlatformAdminUI-RHFSelect-PhoneSelect"
    >
      {options.map((option) => (
        <MenuItem
          key={option.label}
          value={option.value}
          data-testid={`PlatformAdminUI-RhfSelect-MenuList-${option.label}`}
        >
          {option.label}
        </MenuItem>
      ))}
    </StyledSelect>
  );
};

RhfSelect.propTypes = {
  determineCanSave: PropTypes.func.isRequired,
  field: PropTypes.object.isRequired,
  options: PropTypes.array.isRequired,
  dispatch: PropTypes.func,
};
